import { Button } from '@components/ui/button'

const BlockActions = ({
  isFirstBlock,
  isLastBlock,
  onBack,
  isSubmitting,
  isSubmissionClosed,
  submissionStatus,
  buttonText = null,
}) => {
  const calculatedButtonText = buttonText || (
    isSubmitting ? 'Saving...' :
      (isLastBlock ?
        ((submissionStatus === 'COMPLETED' || submissionStatus === 'RETURNED') ? 'Submitted' : 'Submit') :
        'Next'
      )
  )

  // For completed/returned submissions, disable submit button on last block only or when submitting. 
  // It should be enabled otherwise for navigation between blocks.
  // @EthanMarrs: this comment was left by a human ;) although I doubt this proves it.
  const isCompletedOrReturned = submissionStatus === 'COMPLETED' || submissionStatus === 'RETURNED' || isSubmissionClosed
  const submitButtonDisabled = isCompletedOrReturned ? isLastBlock : isSubmitting

  return (
    <>
      <Button
        variant='link'
        type='button'
        disabled={isFirstBlock || isSubmitting}
        onClick={onBack}
      >
        Back
      </Button>

      <div className="flex gap-2">
        <Button
          id='submit-button'
          type='submit'
          disabled={submitButtonDisabled}
        >
          {calculatedButtonText}
        </Button>
      </div>
    </>
  )
}

export default BlockActions 
